import { render, staticRenderFns } from "./resultPanel.vue?vue&type=template&id=ad4d5da2&lang=pug&"
import script from "./resultPanel.vue?vue&type=script&lang=js&"
export * from "./resultPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports